import { createEpicFromAsyncAction } from '../../../utils';
import { fetchExchangeRates } from './exchangeRateSlices';

const fetchExchangeRates$ = createEpicFromAsyncAction(fetchExchangeRates, (payload, { exchangeRateClient }) =>
    exchangeRateClient.getAllExchangeRates()
);

export default [fetchExchangeRates$];
